module.exports = __webpack_public_path__ + "media/images/icons/arrow-circle-left-c55b39c17992bd6890fb9ec90963ead9.svg";